import PropTypes from 'prop-types';

const specialData = PropTypes.shape({
  description: PropTypes.string,
  name: PropTypes.string,
  type: PropTypes.string
});

export const specialPropType = PropTypes.oneOfType([
  specialData,
  PropTypes.arrayOf(specialData)
]);

export const partsImagesProptype = PropTypes.arrayOf(
  PropTypes.shape({
    title: PropTypes.string,
    type: PropTypes.string,
    url: PropTypes.string
  })
);

export const errorInfoProptype = PropTypes.shape({
  domain: PropTypes.string,
  path: PropTypes.string
});

export const attributesPropType = PropTypes.arrayOf(
  PropTypes.shape({
    id: PropTypes.string,
    count: PropTypes.string,
    label: PropTypes.string
  })
);
